import { render } from "./V2SupportModal.vue?vue&type=template&id=ad5e07f8&scoped=true"
import script from "./V2SupportModal.vue?vue&type=script&lang=js"
export * from "./V2SupportModal.vue?vue&type=script&lang=js"

import "./V2SupportModal.vue?vue&type=style&index=0&id=ad5e07f8&scoped=true&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad5e07f8"]])

export default __exports__